import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getThemeIdFromLocalStorage } from './localStorageThemeSettingUtils';
import { parseJsonString } from 'mini-common-utils/lib/utils/parseJsonString';
import { saveOcsThemeSetting } from '../services/saveOcsThemeSetting';
import { type ThemeId } from '../schema/ThemeId';

const MINI_THEME_SETTING = 'MiniTheme';

export function getThemeSetting(): string {
    const primeSettings = getUserConfiguration()?.PrimeSettings;
    const miniThemeSetting = primeSettings?.Items?.find(item => item.Id === MINI_THEME_SETTING);
    let miniThemeSettingValue = miniThemeSetting?.Value?.[0]?.value;

    const miniThemeSettingJson: {
        themeId?: string;
    } | null = parseJsonString(miniThemeSettingValue);
    let settingThemeId = undefined;

    if (miniThemeSettingJson) {
        settingThemeId = miniThemeSettingJson?.themeId;
    } else {
        settingThemeId = miniThemeSettingValue;
    }

    const themeId = settingThemeId ?? getThemeIdFromLocalStorage() ?? 'Blue';

    if (miniThemeSetting && (!miniThemeSettingValue || !miniThemeSettingJson)) {
        saveOcsThemeSetting(themeId);
    }

    return themeId;
}
